export default function initToursLanding($) {
  var landing = document.querySelector('.tours-landing');
  if (!landing) {
    return;
  }

  var initShow = 12;
  var counter = initShow;
  var tourCards = Array.prototype.slice.call(landing.querySelectorAll('.tours-grid__list article'));
  var loadMoreWrapper = landing.querySelector('.load-more');
  var loadMoreButton = landing.querySelector('.load-more a');

  function getTourIds() {
    return tourCards.map(function(item) {
      var dataId = parseInt(item.getAttribute('data-tour-id'), 10);
      if (dataId) {
        return dataId;
      }
      var idAttr = item.getAttribute('id') || '';
      var match = idAttr.match(/post-(\d+)/);
      return match ? parseInt(match[1], 10) : null;
    }).filter(function(id) {
      return !!id;
    });
  }

  function sendTourResults(ids) {
    if (typeof netsTours === 'undefined' || !netsTours.ajaxUrl) {
      return;
    }
    if ($ && $.post) {
      $.post(netsTours.ajaxUrl, {
        action: 'nets_set_tour_results',
        nonce: netsTours.nonce,
        ids: ids,
        source_url: window.location.href
      });
      return;
    }

    var request = new XMLHttpRequest();
    var data = new URLSearchParams();
    data.append('action', 'nets_set_tour_results');
    data.append('nonce', netsTours.nonce);
    data.append('source_url', window.location.href);
    ids.forEach(function(id) {
      data.append('ids[]', id);
    });
    request.open('POST', netsTours.ajaxUrl, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request.send(data.toString());
  }

  function loadMore(toShow) {
    tourCards.forEach(function(card, index) {
      card.classList.toggle('hidden', index >= toShow);
    });

    if (!loadMoreWrapper) {
      return;
    }

    if (tourCards.length <= toShow) {
      loadMoreWrapper.style.display = 'none';
    } else {
      loadMoreWrapper.style.display = '';
    }
  }

  loadMore(counter);

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function(e) {
      e.preventDefault();
      counter += initShow;
      loadMore(counter);
    });
  }

  var ids = getTourIds();
  if (ids.length) {
    sendTourResults(ids);
  }
}
